import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=1fbd7226&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=1fbd7226&prod&lang=scss"
import style1 from "./_slug.vue?vue&type=style&index=1&id=1fbd7226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbd7226",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Advertisement: require('/app/components/Advertisement.vue').default})
